import { cn } from "@/lib/utils"
import { 
  Home, 
  ShoppingBag, 
  Users, 
  Activity, 
  User 
} from "lucide-react"

interface NavItem {
  id: string
  label: string
  icon: React.ElementType
  href: string
}

const navItems: NavItem[] = [
  { id: 'home', label: 'Home', icon: Home, href: '/' },
  { id: 'shop', label: 'Shop', icon: ShoppingBag, href: '/shop' },
  { id: 'studio', label: 'Studio', icon: Users, href: '/studio' },
  { id: 'move', label: 'Move', icon: Activity, href: '/move' },
  { id: 'profile', label: 'Profile', icon: User, href: '/profile' },
]

interface BottomNavProps {
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
}

export function BottomNav({ activeTab, onTabChange, className }: BottomNavProps) {
  return (
    <nav className={cn(
      "fixed bottom-0 left-0 right-0 z-50 border-t border-border",
      "bg-card/80 backdrop-blur-lg",
      className
    )}>
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = activeTab === item.id
            
            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={cn(
                  "flex flex-col items-center gap-1 px-3 py-2 rounded-lg",
                  "transition-all duration-200 min-w-[60px]",
                  isActive 
                    ? "text-primary bg-primary/10" 
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                <Icon 
                  size={20} 
                  className={cn(
                    "transition-all duration-200",
                    isActive && "scale-110"
                  )} 
                />
                <span className="text-xs font-medium">
                  {item.label}
                </span>
              </button>
            )
          })}
        </div>
      </div>
    </nav>
  )
}